<div class="card mx-auto" style="max-width: 500px;">
  <div class="card-body ">
    <h4 class="card-title">Signup</h4>

    <div class="mb-3">
      <label>Username</label>
      <input class="form-control" [(ngModel)]="username" name="username" />
    </div>

    <div class="mb-3">
      <label>Email</label>
      <input class="form-control" [(ngModel)]="email" name="email" type="email" />
    </div>

    <div class="mb-3">
      <label>Password</label>
      <div class="input-group">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="form-control"
          [(ngModel)]="password"
          name="password"
          (input)="checkPasswordStrength(password)"
        />
        <button class="btn btn-outline-secondary" (click)="toggleShowPassword()">
          {{ showPassword ? 'Hide' : 'Show' }}
        </button>
      </div>
      <small class="text-danger" *ngIf="passwordError">{{ passwordError }}</small>
    </div>

    <!-- Additional Fields -->
    <div class="mb-3">
      <label>First Name</label>
      <input class="form-control" [(ngModel)]="firstname" name="firstname" />
    </div>
    <div class="mb-3">
      <label>Last Name</label>
      <input class="form-control" [(ngModel)]="lastname" name="lastname" />
    </div>
    <div class="mb-3">
      <label>Phone Number</label>
      <input class="form-control" [(ngModel)]="phoneNumber" name="phoneNumber" type="tel" />
    </div>
    <div class="mb-3">
      <label>Address</label>
      <input class="form-control" [(ngModel)]="address" name="address" />
    </div>
    <div class="mb-3">
      <label>City</label>
      <input class="form-control" [(ngModel)]="city" name="city" />
    </div>
    <div class="mb-3">
      <label>State</label>
      <input class="form-control" [(ngModel)]="state" name="state" />
    </div>
    <div class="mb-3">
      <label>Country</label>
      <input class="form-control" [(ngModel)]="country" name="country" />
    </div>
    <div class="mb-3">
      <label>Department</label>
      <input class="form-control" [(ngModel)]="department" name="department" />
    </div>
    <div class="mb-3">
      <label>Title</label>
      <input class="form-control" [(ngModel)]="title" name="title" />
    </div>

    <!-- Image Upload -->
    <div class="mb-3">
      <label>Upload Image</label>
      <input class="form-control" type="file" (change)="onFileSelected($event)" name="image" accept="image/*"/>
    </div>

    <button class="btn btn-primary" (click)="onSignup()">Signup</button>
  </div>
</div>
